function unnparse(v) {
  return v ? v.toString() : null;
}

export default unnparse;
